// removed by extract-text-webpack-plugin
module.exports = {"presenter-bio-editor":"style__presenter-bio-editor___3cqIL","action-panel":"style__action-panel_____om5","action-button":"style__action-button___1xcon"};


//////////////////
// WEBPACK FOOTER
// ./components/PresenterForm/style.scss
// module id = 1307
// module chunks = 0